import ConfirmPhoneForm from "../ConfirmPhoneFromsClass";
import Utils from '../UtilsClass';

export default class Profile extends ConfirmPhoneForm {
    constructor() {
        super('.forms_group_finish_register');
        this.initial();
    }

    initial() {
        this.changeUsersInfo();
        this.menu();
        this.infoWindows();
        this.toggleInfoOrder();
        this.ratingSelect();
        this.addMorePhone();
        this.favoriteActions();
        this.favoriteCalculate();
        this.saveAddress();
        this.editAddress();
        this.deleteAddress();
        this.confirmDeleteSocial();
    }

    /**
     * Finished register
     */
    formValidator($form) {
        let $this = this,
            $inF = $form.validate({
                highlight: function (element) {
                    $(element).parent().addClass("error").removeClass("valid");
                },
                unhighlight: function (element) {
                    $(element).parent().removeClass("error").addClass("valid");
                },
                submitHandler: function (form) {
                    //Check actions
                    let action = $(form).attr('action'),
                        dataTo = $(form).attr('data-to'),
                        formData = new FormData($(form)[0]);

                    $(form).find('button[type="submit"]').prop('disabled', true);
                    $($this.formsGroup).find(' > form .btn-area a.to_form').addClass('disabled');

                    $.ajax({
                        type: "POST",
                        url: action,
                        processData: false,
                        contentType: false,
                        data: formData,
                        dataType: "json"
                    })
                    .then(function (resp) {

                            if (!resp.success) {
                                $this.showFormError($form, resp.message);
                                return;
                            }

                            $this.hideFormError($form);

                            //Send sms and show code form
                            if(resp.data['register_finish_1']) {
                                $(form).animate({opacity: 0}, 200, function() {
                                    //Hide from
                                    $(form).hide();

                                    //Initial sms timer
                                    if($(dataTo).attr('data-timer')) {
                                        $this.timerSendSms($(dataTo));

                                        $(dataTo).on('click', '.send_sms_again a', function (e) {
                                            e.preventDefault();
                                            if($(this).hasClass('active')) {
                                                $this.timerSendSms($(dataTo));
                                                if($(dataTo).attr('data-parent')) {
                                                    //TODO: need reset form?
                                                    $($(dataTo).attr('data-parent')).trigger('submit');
                                                }
                                            }
                                        });

                                        //Set phone number
                                        let phone = $(form).find('input[type="tel"]').val();
                                        $(dataTo).find('.header_info .number').html(phone);
                                        $(dataTo).find('input[name="phone_number"]').val(phone);
                                    }

                                    //Hide info window
                                    $(form).closest('.content').find('> .info-window.error').fadeOut(200);

                                    //Show next block
                                    $(dataTo).show();
                                    $(dataTo).animate({opacity: 1}, 200);
                                });
                            }

                            //Success auth|register
                            if(resp.data['register_finish_2']) {
                                window.location.href = resp.data['url'];
                            }
                        })
                        .fail(function (xhr) {
                            $this.ajaxErrorForm($inF, xhr);
                        })
                        .always(function () {
                            $(form).find('button[type="submit"]').prop('disabled', false);
                            $($this.formsGroup).find('> form .btn-area a.to_form').removeClass('disabled');
                        });
                }
            });

        this.initForms.push($inF);
    }

    /**
     * Change user`s info
     */
    changeUsersInfo() {
        let $this = this,
            $form = $('#profile_user_info'),
            $inF = $form.validate({
            highlight: function (element) {
                $(element).parent().addClass("error").removeClass("valid");
            },
            unhighlight: function (element) {
                $(element).parent().removeClass("error").addClass("valid");
            },
            submitHandler: function (form) {
                //Check actions
                let action = $(form).attr('action'),
                    formData = new FormData($(form)[0]);

                $(form).find('button[type="submit"]').prop('disabled', true);
                $($this.formsGroup).find(' > form .btn-area a.to_form').addClass('disabled');
                $('#profile_user_info_error, #profile_user_info_success').fadeOut(200);

                $.ajax({
                    type: "POST",
                    url: action,
                    processData: false,
                    contentType: false,
                    data: formData
                })
                    .then(function (resp) {
                        if (!resp.success) {
                            $this.showFormError($form, resp.message);
                            $('#profile_user_info_error').fadeIn(200);
                            return;
                        }
                        $this.hideFormError($form);
                        $('#profile_user_info_success').fadeIn(200);
                    })
                    .fail(function (xhr) {
                        $this.ajaxErrorForm($inF, xhr);
                    })
                    .always(function () {
                        $(form).find('button[type="submit"]').prop('disabled', false);
                        $($this.formsGroup).find('> form .btn-area a.to_form').removeClass('disabled');
                    });
            }
        });
    }

    /**
     * Toggle menu on mobile
     */
    menu() {
        let $mobProfMenu = $('.mob-catalog--profile');
        $mobProfMenu.find('a.prof-menu').on('click', function () {
            $(this).toggleClass('open');
            $mobProfMenu.find('.mob-profile-catalog').slideToggle(200);
        })
    }

    /**
     * Action with info windows
     */
    infoWindows() {
        let $infoWindows = $('.info-window');
        $infoWindows.find('.close').on('click', function (e) {
            e.preventDefault();
            $(this).closest('.info-window').fadeOut(200);
        });
    }

    /**
     * Open|close information about order
     */
    toggleInfoOrder() {
        let $orderL = $('.orders_list');
        if($orderL.length) {
            $orderL.on('click', '.item_dash_row--order .item_dash_row_header', function () {
                $(this).parent().toggleClass('open');
                $(this).siblings('.item_dash_row_content').slideToggle(200);
            });
        }
    }

    /**
     * Set rating on review form
     * TODO: duplicate
     */
    ratingSelect() {
        let $rating = $('.rating_can_select');

        $rating.find('.review_star li').hover(function () {
            let $this = $(this);
            $this.closest('.review_star').find('i').removeClass('icon-star');
            $this.closest('.review_star').find('i').addClass('icon-star-border');
            $this.closest('.review_star').find('li').each(function (index) {
                $(this).find('i').removeClass('icon-star-border');
                if($this.index() !== index) {
                    $(this).find('i').addClass('icon-star');
                } else {
                    $(this).find('i').addClass('icon-star');
                    return false;
                }
            });
        });

        $rating.on('mouseleave', function () {
            $(this).find('i').removeClass('icon-star').addClass('icon-star-border');
            $(this).find('i.fix').addClass('icon-star').removeClass('icon-star-border');
        });

        $rating.find('.review_star li').on('click', function () {
            let $this = $(this);
            $this.closest('.review_star').find('i').removeClass('fix icon-star').addClass('icon-star-border');
            $this.closest('.review_star').find('li').each(function (index) {
                if($this.index() !== index) {
                    $(this).find('i').removeClass('icon-star-border').addClass('fix icon-star');
                } else {
                    $(this).find('i').removeClass('icon-star-border').addClass('fix icon-star');
                    return false;
                }
            });

            $this.closest('.rating_can_select').find('input[name="rating"]').val($this.attr('data-r'));
        });
    }

    /**
     * Add more phone when user create new address in "Address delivery"
     */
    addMorePhone() {
        let $nP = $('.prof_delivery_form');
        if($nP.length) {
            let $cp = $('.special_copy_phone'),
                idNewPhone = 1;
            $nP.on('click', '#new-phone', function (e) {
                e.preventDefault();
                let $newPhone = $cp.clone();

                $newPhone.find('input').removeClass('full special_copy_phone').val('');
                $newPhone.find('input').parent().removeClass('error');
                $newPhone.find('input').attr('id', 'new-phone-' + idNewPhone);
                $newPhone.find('label').attr('for', 'new-phone-' + idNewPhone);
                $(this).before($newPhone);

                Utils.phoneMask();

                idNewPhone++;
            });
        }
    }


    /**
     * Create\Delete lists & other options
     * NOTE: Remove list will created in FavoriteActionsClass
     */
    favoriteActions() {
        let self = this,
            $favList = $('.favorites_list');
        if($favList.length) {
            //Group control
            $favList.on('change', '.content_items .item_control input[type="checkbox"]', function () {
                let countCheck = $(this).closest('.content_items').find('.item_control input[type="checkbox"]:checked').length,
                    $controlOption = $(this).closest('.fv_content_products').find('.content_options .control_option .control_block');
                if(countCheck > 0) {
                    $controlOption.fadeIn(200);
                } else {
                    $controlOption.fadeOut(200);
                }
            });

            //Open\close inform about list
            $favList.on('click', '.fv_products_wrap .header .title_for_block', function () {
                $(this).toggleClass('open');
                $(this).closest('.header').siblings('.fv_content_products').slideToggle(200, function () {
                    $(".dotdotdot:not(.ddd-truncated)").dotdotdot({
                        height: 60,
                        watch: 'window'
                    });
                });
            });

            //Create new list
            $('#new_fav_list form, #edit_fav_list form, #change_fav_list form').each(function () {
                let $thisF = $(this).validate({
                    highlight: function (element) {
                        $(element).parent().addClass("error").removeClass("valid");
                    },
                    unhighlight: function (element) {
                        $(element).parent().removeClass("error").addClass("valid");
                    },
                    submitHandler: function (form) {
                        //Check actions
                        let action = $(form).attr('action'),
                            formData = new FormData($(form)[0]);

                        $(form).find('button[type="submit"]').prop('disabled', true);

                        $.ajax({
                            type: "POST",
                            url: action,
                            processData: false,
                            contentType: false,
                            data: formData
                        }).done(function (res) {
                            if(res.success) {
                                $(form).fadeOut(200, function () {
                                    $(form).siblings('.thanks').fadeIn(200);

                                    $('#xhr-fav-big-list').html(res.data.html.big);

                                    if(res.data.html.list_categories) {
                                        $('#xhr-fav-cat-list').html(res.data.html.list_categories);
                                    }

                                    $(form)[0].reset();
                                    $thisF.resetForm();
                                    self.favoriteCalculate();
                                });
                                return true;
                            }
                        })
                        .always(function () {
                            $(form).find('button[type="submit"]').prop('disabled', false);
                        })
                    }
                });
            });

            //Edit list
            $favList.on('click', '.edit_fav_list', function (e) {
                e.preventDefault();
                let $edForm = $('#edit_fav_list form'),
                    id = $(this).attr('data-id'),
                    name = $(this).attr('data-name'),
                    is_main = $(this).attr('data-main');

                $edForm.append('<input type="hidden" name="category_id" value="'+ id +'">');
                $edForm.find('input[name="name"]')
                    .addClass('full')
                    .val(name);

                if(is_main === '1') {
                    $edForm.find('input[name="is_main"]')
                        .prop('checked', true)
                        .prop('disabled', true);
                    $edForm.append('<input type="hidden" class="custom_main" name="is_main" value="1">');
                } else {
                    $edForm.find('input.custom_main').remove();
                    $edForm.find('input[name="is_main"]')
                        .prop('disabled', false)
                        .prop('checked', false);
                }
            });

            //Select products
            $favList.on('change', '.fv_products_wrap .item_product_first input[name="item[]"]', function () {
                self.favoriteCalculate();
            });

            //Change list
            $favList.on('click', '.fav_change_list', function () {
                $('#change_fav_list form input[name="product_ids"]').val($(this).attr('data-ids'));
            });

            //Trigger calculate
            $(document).bind('fav.calculate.products', function () {
                self.favoriteCalculate();
            })

        }
    }
    favoriteCalculate() {
        let $favBlocks = $('.favorites_list');
        $favBlocks.find('.fv_products_wrap').each(function () {
            let $contentOpt = $(this).find('.content_options'),
                $products = $(this).find('input[name="item[]"]:checked').length ? $(this).find('input[name="item[]"]:checked').closest('.item_product_first').find('span[data-price-now]') : $(this).find('span[data-price-now]'),
                price = 0;

            if($products.length) {
                $contentOpt.show();
                $products.each(function () {
                    price += parseFloat($(this).attr('data-price-now'));
                });
                $contentOpt.find('.count').html($products.length);
                $contentOpt.find('.price').html(price.toLocaleString('ru-RU', {maximumFractionDigits: 2, minimumFractionDigits: 2}));

                let arrEnding = $contentOpt.find('.ending_count').attr('data-val').split('|');
                $contentOpt.find('.ending_count').html(Utils.declOfNum($products.length, arrEnding));

                //Ids
                if($(this).find('input[name="item[]"]:checked').length) {
                    let values = $(this).find('input[name="item[]"]:checked').map(function(){return $(this).val();}).get();
                    $contentOpt.find('.add_to_cart_arr')
                        .removeClass('disabled')
                        .attr('data-ids', values);
                    $contentOpt.find('.fav_change_list, .remove_fav_ids').attr('data-ids', values);
                } else {
                    $contentOpt.find('.add_to_cart_arr')
                        .addClass('disabled')
                        .attr('data-ids', '');
                    $contentOpt.find('.fav_change_list, .remove_fav_ids').attr('data-ids', '');
                }
            } else {
                $contentOpt.hide();
            }
        });
    }

    /**
     * Action with address ADD|EDIT|DELETE
     */
    saveAddress() {
        let self = this,
            $addressDelivery = $('.prof_delivery_form');
        $addressDelivery.each(function () {
            let $thisF = $(this).validate({
                highlight: function (element) {
                    $(element).parent().addClass("error").removeClass("valid");
                },
                unhighlight: function (element) {
                    $(element).parent().removeClass("error").addClass("valid");
                },
                submitHandler: function (form) {
                    //Check actions
                    let action = $(form).attr('action'),
                        formData = new FormData($(form)[0]);

                    $(form).find('button[type="submit"]').prop('disabled', true);
                    $.ajax({
                        type: "POST",
                        url: action,
                        processData: false,
                        contentType: false,
                        data: formData,
                        dataType: 'json',
                    }).done(function (res) {
                        if(res.success) {
                            $(form).fadeOut(200, function () {
                                $(form).siblings('.thanks').fadeIn(200);
                                $(form).find('button[type="submit"]').prop('disabled', false);

                                //Clear
                                $(form)[0].reset();
                                $thisF.resetForm();
                                $(form).find('.full:not([name="date_from"]):not([name="date_to"])').removeClass('full');
                                $(form).find('.drop_down-list li').removeClass('active');
                            });
                            self.updateAddressList();
                            return true;
                        }
                        alert('Упс.');
                    });
                }
            });
        })
    }
    editAddress() {
        let self = this;
        $('.address_list').on('click', 'a.edit-address', function () {
            let action = $(this).attr('data-url'),
                $form = $($(this).attr('data-fade') + ' form');

            $.ajax({
                type: "GET",
                url: action,
            }).done(function (res) {
                $form.html(res);

                setTimeout(function () {
                    Utils.customSelect();
                    Utils.phoneMask();
                    self.saveAddress();
                }, 200);
            });

        });
    }
    deleteAddress() {
        let self = this;
        $('.address_list').on('click', 'a.delete-address', function () {

            let confName = 'confirm:delete',
                action = $(this).attr('data-url');

            $(document).bind(confName, function () {
                $(document).unbind(confName);

                $.ajax({
                    type: "GET",
                    url: action,
                    processData: false,
                    contentType: false,
                    dataType: "json"
                }).done(function (res) {
                    if(res.success) {
                        self.updateAddressList();
                        return true;
                    }
                    alert('Error');
                })
                .fail(function (xhr) {
                    alert('Error');
                })
                .always(function () {
                    $('#confirm_delete .close-popup').trigger('click');
                });
            });

            self.confirmAction(confName);
        });
    }
    updateAddressList() {
        if ('addressUpdateUrl' in window) {
            $.ajax({
                type: "GET",
                url: addressUpdateUrl,
                processData: false,
                contentType: false,
                dataType: "json",
                success: function (res, textStatus, jqXHR) {
                    if(res.success) {
                        $('.address_list .content').html(res.data.html);
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    alert('Error update');
                }
            });
        }
    }

    /**
     * Confirm delete relationships witch socials
     */
    confirmDeleteSocial() {
        let self = this;

        $('.detach-social').on('click', function () {
            let confName = 'confirm:delete:social',
                action = $(this).attr('data-url');

            $(document).bind(confName, function () {
                $(document).unbind(confName);
                window.location.href = action;
            });

            self.confirmAction(confName);
        });
    }

    //TODO: move t global
    confirmAction(confName) {
        $('#confirm_delete button[type=button]').on('click', function (){
            $(document).trigger(confName);
        });
    }
}
